import { useToast } from "@src/lib/hooks/useToast";
import { Button } from "@src/lib/ui/Button";
import { Input } from "@src/lib/ui/Input";
import Text from "@src/lib/ui/Text";
import { FC, useState } from "react";
import isURL from "validator/lib/isURL";

type Props = {
  onAddLink: (link: string) => void;
};

const PasteLink: FC<Props> = (props) => {
  const [text, setText] = useState("");
  const { addErrorToast } = useToast();
  return (
    <>
      <Text variant="compact-title" className="mb-1">
        Paste link
      </Text>
      <Input
        placeholder="Paste link here"
        className="w-full"
        value={text}
        onChange={(e) => {
          setText(e.target.value);
        }}
      />
      <Text
        variant="fine-print-description"
        className="my-1 text-muted-foreground"
      >
        Opus automatically embeds any YouTube or Vimeo links
      </Text>
      <Button
        onClick={() => {
          if (isURL(text, { protocols: ["https"] })) {
            props.onAddLink(text);
          } else {
            addErrorToast({
              message: "Invalid link. Please paste a valid link.",
              callsite: "add_media_paste_link",
            });
          }
        }}
      >
        Submit
      </Button>
    </>
  );
};

export default PasteLink;
